import Image from 'components/Common/Image'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import styled from 'styled-components'
import type { ImageAttachment } from '@luxuryescapes/contract-svc-lab'

const Container = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  background-color: ${props => props.theme.palette.neutral.surface.normalBackground};
  overflow: hidden;
`

const Gradient = styled.div`
  position: absolute;
  inset: 0;
  width: 100%;
`

const AbsoluteImageContainer = styled.div<{
  $top?: string
  $left?: string
  $right?: string
  $bottom?: string
}>`
  position: absolute;
  top: ${props => props.$top ?? 'auto'};
  left: ${props => props.$left ?? 'auto'};
  right: ${props => props.$right ?? 'auto'};
  bottom: ${props => props.$bottom ?? 'auto'};
`

interface Props {
  imageId: string
  backgroundStyle?: string
  className?: string
  attachments?: Array<ImageAttachment>
}

const DEFAULT_ATTACHMENTS: Array<ImageAttachment> = []

export function GenericBackgroundImage({
  imageId,
  className,
  backgroundStyle,
  attachments = DEFAULT_ATTACHMENTS,
}: Props) {
  const imageProps = {
    id: imageId,
    dpr: 2 as const,
    fit: 'center' as const,
  }

  return (
    <Container className={className}>
      <Image {...imageProps} />
      {backgroundStyle && <Gradient style={{ background: backgroundStyle }} />}
      {attachments.map((attachment, index) => {
        const imageElement = (
          <AbsoluteImageContainer
            key={`${attachment.imageId}-${index}`}
            $top={attachment.top}
            $left={attachment.left}
            $right={attachment.right}
            $bottom={attachment.bottom}
          >
            <Image
              id={attachment.imageId}
              dpr={2}
              fit="center"
              width={attachment.width}
              height={attachment.height}
            />
          </AbsoluteImageContainer>
        )

        if (attachment.min || attachment.max) {
          return (
            <CSSBreakpoint
              key={`${attachment.imageId}-${index}`}
              min={attachment.min}
              max={attachment.max}
            >
              {imageElement}
            </CSSBreakpoint>
          )
        }

        return imageElement
      })}
    </Container>
  )
}
